/**
 * To generate the ./layout/spacing definitions, run yarn make-layout
 */
import * as React from "react";
import { css } from "emotion";
import styled from "react-emotion";
import { breakpoints as BREAKPOINTS_ } from "./layout/layoutConfig";
import * as breakpoints_ from "./layout/breakpoints";
import * as spacing_ from "./layout/spacing";
export const BREAKPOINTS = BREAKPOINTS_;
export const breakpoints = breakpoints_;
/**
 * Spacing
 *
 * Spaces define the distance beween components in a layout. They follow
 * a brief but powerful naming convention:
 *
 *                               TYPE       SIDES         SPACE
 *     <div class="plm"></div>   <p>adding  <l>eft        <m>edium
 *     <div class="mbs"></div>   <m>argin   <b>ottom      <s>mall
 *     <div class="pvs"></div>   <p>adding  <v>ertical    <s>mall
 *     <div class="mhl"></div>   <m>argin   <h>orizontal  <l>arge
 *
 * Types  - <p>adding, <m>argin
 * Sides  - <a>ll, <t>op, <r>ight, <b>ottom, <l>eft, <h>orizontal, <v>ertical
 * Spaces - As defined in the global $spaces variable, e.g. <n>one, <s>mall, <l>arge
 *
 * Origin: https://github.com/interactivethings/catalyst/blob/master/src/_spaces.scss
 * Refinement: http://tachyons.io/docs/layout/spacing/
 */
export const spacing = spacing_;
const space = (s) => {
    const sArr = typeof s === "string" ? [s] : s;
    return css(sArr.reduce((m, x) => ({ ...m, ...spacing[x] }), {}));
};
export const Space = (props) => {
    const { children, ...spaceProps } = props;
    const spaces = Object.keys(spaceProps).filter(sp => sp in spacing);
    return (<div className={css `
        ${space(spaces)};
      `}>
      {children}
    </div>);
};
/**
 *
 */
export const container = css `
  margin: 0 auto;
  max-width: 978px;
  ${spacing.ph3};
  ${breakpoints.large `
  ${spacing.ph5};
`};
`;
export const Container = styled("div") `
  label: Container;
  ${container};
`;



// WEBPACK FOOTER //
// ./src/theme/layout.tsx